var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51161 4.42211L12.1176 1.80798C12.357 1.56637 12.357 1.17688 12.1176 0.935273C11.8768 0.694985 11.4874 0.694985 11.248 0.935273L8.64344 3.55073C8.40271 3.79102 8.40271 4.18182 8.64344 4.42211C8.88285 4.66372 9.27219 4.66372 9.51161 4.42211Z",
    fill: "#D1CDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1067 1.32344V14.8838C11.1067 15.2245 11.3816 15.5004 11.721 15.5004C12.0603 15.5004 12.3353 15.2245 12.3353 14.8838V1.32344C12.3353 0.984137 12.0603 0.706909 11.721 0.706909C11.3816 0.706909 11.1067 0.984137 11.1067 1.32344Z",
    fill: "#D1CDD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3463 1.80798L13.9509 4.42211C14.1916 4.66372 14.581 4.66372 14.8204 4.42211C15.0598 4.18182 15.0598 3.79102 14.8204 3.55073L12.2145 0.935273C11.9751 0.694985 11.5857 0.694985 11.3463 0.935273C11.1056 1.17688 11.1056 1.56637 11.3463 1.80798Z",
    fill: "#D1CDD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48837 11.5792L2.88242 14.1934C2.64301 14.435 2.64301 14.8244 2.88242 15.066C3.12183 15.3063 3.51118 15.3063 3.75059 15.066L6.35654 12.4506C6.59595 12.2103 6.59595 11.8195 6.35654 11.5792C6.11713 11.3376 5.72779 11.3376 5.48837 11.5792Z",
    fill: "#D1CDD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89548 14.6766V1.11618C3.89548 0.776872 3.62057 0.499603 3.28118 0.499603C2.9418 0.499603 2.66689 0.776872 2.66689 1.11618V14.6766C2.66689 15.0172 2.9418 15.2931 3.28118 15.2931C3.62057 15.2931 3.89548 15.0172 3.89548 14.6766Z",
    fill: "#D1CDD6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65496 14.1934L1.04909 11.5792C0.80968 11.3376 0.42029 11.3376 0.17956 11.5792C-0.0598534 11.8195 -0.0598534 12.2103 0.17956 12.4506L2.78551 15.066C3.02492 15.3063 3.41424 15.3063 3.65496 15.066C3.89438 14.8244 3.89438 14.435 3.65496 14.1934Z",
    fill: "#D1CDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.a694ed8666d8ba3a06720870c0d62e6e.svg";
export { ForwardRef as ReactComponent };